import { readStats, IUser } from "@/api";
import { ClauseChecklists } from "@/components/shared/graphs/clause-checklists/ClauseChecklists";
import { HomePageHeader } from "@/components/shared/layout/HomePageHeader";
import { Box, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ClauseDownvotes } from "./ClauseDownvotes";
import { ScopeAccuracy } from "./ScopeAccuracy";
import { TotalsContainer } from "./TotalsContainer";

interface StatsDashboardProps {
    user: IUser;
}

export const StatsDashboard = ({ user }: StatsDashboardProps) => {
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down("lg"));

    const { data } = useSuspenseQuery({
        queryKey: ["admin-home"],
        queryFn: readStats,
    });

    if (responsive) {
        return (
            <Stack spacing={3} width={"100%"} flex={1}>
                <HomePageHeader user={user} />

                <TotalsContainer stats={data} />
                <Box height={400} width={"100%"}>
                    <ClauseDownvotes clauses={data.clauses} />
                </Box>
                <Box width={"100%"}>
                    <ClauseChecklists
                        clauseChecklists={data.clause_checklists}
                    />
                </Box>
                <Box height={400} width={"100%"}>
                    <ScopeAccuracy scopeAccuracy={data.scope_accuracy} />
                </Box>
            </Stack>
        );
    }

    return (
        <Stack spacing={2} flex={1} width={"100%"}>
            <Stack direction={"row"} width={"100%"} spacing={3} maxHeight={300}>
                <Stack width={"100%"} spacing={2} flex={1.5}>
                    <HomePageHeader user={user} />
                    <TotalsContainer stats={data} />
                </Stack>
                <Stack flex={1}>
                    <ClauseChecklists
                        clauseChecklists={data.clause_checklists}
                    />
                </Stack>
            </Stack>

            <Stack direction={"row"} height={500} spacing={3}>
                <Stack flex={1.5}>
                    <ClauseDownvotes clauses={data.clauses} />
                </Stack>

                <Stack flex={1}>
                    <ScopeAccuracy scopeAccuracy={data.scope_accuracy} />
                </Stack>
            </Stack>
        </Stack>
    );
};
